import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-4 bg-brand-slate/30" data-id="element-146">
      <div className="max-w-2xl mx-auto" data-id="element-147">
        <FadeIn data-id="element-148">
          <div className="flex flex-col sm:flex-row items-start gap-5 p-6 md:p-8 rounded-2xl bg-brand-dangerBg border border-brand-danger/20 relative overflow-hidden" data-id="element-149">
            <div className="absolute top-0 left-0 w-1 h-full bg-brand-danger/50" data-id="element-150" />
            <AlertCircle className="w-8 h-8 text-brand-danger flex-shrink-0 mt-1 opacity-80" data-id="element-151" />
            <p className="text-lg text-brand-text leading-relaxed" data-id="element-152">
              Llevas semanas, quizá meses, intentando "soltar". Has escuchado
              que "el tiempo lo cura todo", pero para ti el tiempo solo parece
              hacer el nudo más fuerte. Te despiertas con su nombre en la
              cabeza. Pasas el día analizando qué hiciste mal. Te acuestas
              imaginando conversaciones que nunca ocurrirán. Estás agotado de
              vivir en un pasado que ya no te pertenece, mientras tu presente se
              escurre entre tus dedos.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}